import { GeneralExpenseReportFormState } from '../pages/forms/general-expense-report/schema';
import { TravelExpenseReportFormState } from '../pages/forms/travel-expense-report/schema';
import { SignedUrl } from './forms';

export enum ExpenseReportFormType {
  GeneralExpenseReport = 'GeneralExpenseReport', // Kulukorvaus
  TravelExpenseReport = 'TravelExpenseReport', // Matkalasku
}

export enum ExpenseReportFormState {
  Draft = 'Draft',
  AwaitingApproval = 'AwaitingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Archived = 'Archived',
}

interface BaseExpenseReportForm {
  id: string;
  createdBy: string;
  processedAt?: Date;
  formState: ExpenseReportFormState;
  createdAt: Date;
  modifiedAt: Date;
}

export interface GeneralExpenseReport extends BaseExpenseReportForm {
  formType: ExpenseReportFormType.GeneralExpenseReport;
  formData: GeneralExpenseReportFormState;
  signedUrls: SignedUrl[];
}

export interface TravelExpenseReport extends BaseExpenseReportForm {
  formType: ExpenseReportFormType.TravelExpenseReport;
  formData: TravelExpenseReportFormState;
  signedUrls: SignedUrl[];
}

/**
 * Expense report as it appears to the owner of the report.
 */
export type ExpenseReportForm = GeneralExpenseReport | TravelExpenseReport;
